<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <!-- <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button> -->
                        <el-input
                            size="small"
                            style="width:300px;"
                            placeholder="请输入用户手机号 / 任务编号"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.status" clearable placeholder="任务状态">
                            <el-option key="0" label="待支付" value="0"> </el-option>
                            <el-option key="1" label="待审核" value="1"> </el-option>
                            <el-option key="2" label="进行中" value="2"> </el-option>
                            <el-option key="3" label="已完成" value="3"> </el-option>
                            <el-option key="4" label="不通过" value="4"> </el-option>
                        </el-select>
                        <el-date-picker
                        size="small" style="width:300px;margin-left:30px"
                        v-model="queryModel.createTimes"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>

                        
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="模板下载" placement="top">
                            <el-button type="success" style="margin-left:20px;" @click="getExl" icon="el-icon-download" size="small" plain>模板下载</el-button>
                        </el-tooltip>
                        <el-tooltip>
                            <el-button :loading="isOperating" style="margin-left:20px;" @click="importExcel" size="mini" type="primary" icon="el-icon-upload2" plain>匹配导入</el-button>
                        </el-tooltip>
                        <el-tooltip>
                            <el-button :loading="isOperating" style="margin-left:20px;" @click="importExcelNoMatch" size="mini" type="primary" icon="el-icon-upload2" plain>不匹配导入</el-button>
                        </el-tooltip>
                        <input type="file" ref="uploadExcel" v-show="false" accept=".xls,.xlsx" @change="readExcel">     
                        <input type="file" ref="uploadExcelNoMatch" v-show="false" accept=".xls,.xlsx" @change="readExcelNoMatch">                           

                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    :height="bodyHeight-130"
                    v-loading="isLoading"
                    :data="tableData"
                     @selection-change="handleSelectionChange"
                    style="width: 100%">
                        <el-table-column
                        :selectable='checkboxInit'
                        type="selection"
                        width="55">
                        </el-table-column>
                        <el-table-column
                        width="240"
                            label="任务编号">
                            <template slot-scope="scope">
                                <el-link target="_blank" @click="taskGetDetail(scope.row)"  type="primary">{{scope.row.Code}}</el-link>
                                <el-tag size="mini" v-if="scope.row.IsRefundOrder" style="margin-left:10px" effect="dark">退款单 </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="MemberName"
                            label="所属用户">
                            <!-- <template slot-scope="scope">
                                <el-link target="_blank" icon="el-icon-user-solid"  type="primary">{{scope.row.}}</el-link>
                            </template> -->
                        </el-table-column>
                        <el-table-column
                            width="100px"
                            label="垫付额度">
                            <template slot-scope="scope">
                                <span v-if="scope.row.Advance>0">{{scope.row.Advance.toFixed(2)}}元</span>
                                <span v-else>无垫付额度</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="店铺名称">
                            <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.ShopName" placement="bottom">
                                <span v-if="scope.row.ShopType==1" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#ff6a3c;border-radius:5px"  src="../assets/taobao.png">
                                        {{scope.row.ShopName}}
                                        </div>
                                </span>
                                <span v-else-if="scope.row.ShopType==2" >
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#9765ff;border-radius:5px" src="../assets/jindong.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                                <span  v-else>
                                    <div style="margin-left:5px;width:120px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                                        <img  style="margin-bottom:-5px;height:20px;background-color:#fc5487;border-radius:5px"  src="../assets/pinduoduo.png">
                                        {{scope.row.ShopName}}
                                    </div>
                                </span>
                            </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="120px"
                            label="费用明细">
                            <template slot-scope="scope">
                                <el-tooltip   class="item" effect="dark" placement="bottom">
                                    <div slot="content">
                                        <p>预计商品金额：￥ {{scope.row.ExpectedPrice.toFixed(2)}}</p>
                                        <p>预计佣金：￥ {{scope.row.ExpectedCommission.toFixed(2)}}</p>
                                        <p>实际商品金额：{{scope.row.ActualPrice==0?'暂无':'￥ '+scope.row.ActualPrice.toFixed(2)}}</p>
                                        <p>实际佣金：{{scope.row.ActualCommission==0?'暂无':'￥ '+scope.row.ActualCommission.toFixed(2)}}</p>
                                    </div>
                                     <el-link  icon="el-icon-money"  type="primary">￥{{scope.row.Total.toFixed(2)}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="120px"
                            label="商家要求">
                            <template slot-scope="scope">
                                <el-tooltip   class="item" effect="dark" placement="bottom">
                                    <div slot="content">
                                        <p>期望完成时间：
                                            <span >{{scope.row.ExpectedOverTime.toString().split(' ')[0]}}</span>
                                        </p>
                                        <p>返款方式：
                                            <span v-if="scope.row.RebateMethod==0">平台返款</span>
                                            <span v-else-if="scope.row.RebateMethod==1">商家自反</span>
                                            <span  v-else>平台返款</span>
                                        </p>
                                        <p>淘客订单拦截：
                                            <span v-if="scope.row.Intercept==0">否</span>
                                            <span v-else-if="scope.row.Intercept==1">是</span>
                                            <span  v-else>否</span>
                                        </p>
                                        <p>买家性别要求：
                                            <span v-if="scope.row.SwipeGender==1">男</span>
                                            <span v-else-if="scope.row.SwipeGender==2">女</span>
                                            <span  v-else>不限</span>
                                        </p>
                                        <p>买家年龄要求： 
                                            <span v-if="scope.row.SwipeAge==1">22岁以下</span>
                                            <span v-else-if="scope.row.SwipeAge==2">23岁-28岁</span>
                                            <span v-else-if="scope.row.SwipeAge==3">29岁-35岁</span>
                                            <span v-else-if="scope.row.SwipeAge==4">36岁-45岁</span>
                                            <span v-else-if="scope.row.SwipeAge==5">46岁以上</span>
                                            <span  v-else>不限</span>
                                        </p>
                                        <p>买家信誉要求：
                                            <span v-if="scope.row.SwipeBuyerGoodNum==1">二心以上</span>
                                            <span v-else-if="scope.row.SwipeBuyerGoodNum==2">三心以上</span>
                                            <span v-else-if="scope.row.SwipeBuyerGoodNum==3">四心以上</span>
                                            <span v-else-if="scope.row.SwipeBuyerGoodNum==4">五心以上</span>
                                            <span v-else-if="scope.row.SwipeBuyerGoodNum==5">一钻以上</span>
                                            <span  v-else>不限</span>
                                        </p>
                                        <p>特殊要求：{{scope.row.Remark}}</p>
                                        <p>商家要求：{{scope.row.SwipeRemark}}</p>
                                    </div>
                                     <el-link @click="setRequirement(scope.row)" type="primary">查看</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            width="160"
                            label="创建时间">
                        </el-table-column>
                        <el-table-column
                            label="审核信息">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.ReviewManagerName==''" icon="el-icon-user" type="info">暂无</el-link>
                                <el-tooltip  v-else  class="item" effect="dark" placement="bottom-start">
                                    <div slot="content">
                                        时间：{{scope.row.ReviewTime}}<br/><br/>
                                        备注：{{scope.row.ReviewRemark}}<br/><br/>
                                    </div>
                                    <el-link icon="el-icon-user" type="primary">{{scope.row.ReviewManagerName}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="80"
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="info" v-if="scope.row.Status==0">待支付</el-tag>
                                <el-tag size="mini" effect="plain" v-else-if="scope.row.Status==1">待审核</el-tag>
                                <el-tag size="mini" effect="plain" type="warning" v-else-if="scope.row.Status==2">进行中</el-tag>
                                <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.Status==3">已完成</el-tag>
                                <el-tag size="mini" effect="plain" type="danger" v-else-if="scope.row.Status==4">不通过</el-tag>
                                <el-tag size="mini" effect="plain" type="danger" v-else>作废</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="80"
                            label="预计单数">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="dark" type="danger">{{scope.row.ExpectedOrderCount}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="80"
                            label="完成单数">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="dark" type="info" v-if="scope.row.OrderCount==0">暂无</el-tag>
                                <el-tag size="mini" effect="dark" v-else>{{scope.row.OrderCount}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="120"
                            label="开始-结束">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect=""  >{{scope.row.StartHour}} - {{scope.row.EndHour}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="160px"
                            label="操作">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="结算" placement="bottom">
                                    <el-button v-if="scope.row.Status==2"  type="primary" size="mini" @click="overTask(scope.row)" >结算</el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        
                <el-image-viewer 
                style="z-index:999999"
                v-show="showViewer" 
                :on-close="closeImg" 
                :url-list="url" />


    </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

import {orderSetSwipeRemark, orderSetKey, taskAbandoned,taskGroupEnd,pushMain,orderSetPrice, orderCanelInvalid,orderInvalid, orderAdd,taskSetExpectedOverTime,orderBatchAssign,orderGetSwipe,orderSetProblem,taskBatchGet,taskBatchPass,taskBatchOver,commissionGetAll,taskGetDetail,taskOverTaskNoDetail,uri,taskEdit,taskSetTitle,taskSetUrl,taskSetRequirement,taskExistDetail,taskExistDetailNoMatch} from '@/request.js'
import XLSX from 'xlsx'

export default {
    components: {
        ElImageViewer
    },
    data(){
        return {
            isOperating:false,
            videoVisible:false,
            showViewer:false,
            url:[],
            caozuo:false,
            drawer:false,
            dialogFormVisible:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
                status:"",
                createTimes:[],
                payMode:"",
                isMe:false,
                hasAbandoned:false,
            },
            tableData:[],
            overScope:{},
            overType:1,
            overModel:{
                id:0,
                remark:"",
                externalName:"",
                externalCodes:"",
                startHour:0,
                endHour:0,
            },
            rules: {

            },
            problemRules: {
                problem: [
                    { required: true, message: '请填写问题', trigger: 'blur' },
                    { min: 5, max: 100, message: '长度在 5 到 100 个字符', trigger: 'blur' }
                ],
                answer: [
                    { required: true, message: '请填写答案', trigger: 'blur' },
                    { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                ],
            },
            task:{},
            details:[],
            loadingSwipe:false,
            problemModel:{
                taskId:0,
                url:"",
                problem:"",
                answer:"",
            },
            requirementModel:{
                id:0,
                expectedOverTime:"",
                rebateMethod:"",
                intercept:"",
                swipeAge:"",
                swipeGender:"",
                swipeBuyerGoodNum:"",
                remark:"",
                swipeRemark:"",
            },
            problemVisible:false,
            requirementVisible:false,
            setDetailRow:{},
            setRequirementRow:{},
            batchDispatchVisible:false,
            selDetailRows:[],
            selSwipeRow:[],
            swipeList:[],
            undoneNum:0,
            pIndex:1,
            queryTxt:"",
            setExpectedOverTimeVisible:false,
            setRow:{},
            addOrderVisible:false,
            addOrderModel:{
                TaskId:0,
                DetailId:0,
                ShopId:0,
                SwipePhone:"",
                OrderCode:"",
                AliTrademanager:"",
                AdvanceMoney:0,
                Cost:0,
            },
            orderRules: {
                SwipePhone: [
                    { required: true, message: '请填写刷手手机号', trigger: 'blur' },
                    { min: 11, max: 11, message: '长度为 11 个字符', trigger: 'blur' }
                ],
                OrderCode: [
                    { required: true, message: '请填写买手提交单号', trigger: 'blur' },
                ],
                AliTrademanager: [
                    { required: true, message: '请填写买手阿里旺旺', trigger: 'blur' },
                    { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
                ],
                AdvanceMoney: [
                    { required: true, message: '请填写买手实际垫付金额', trigger: 'blur' },
                ],
                Cost: [
                    { required: true, message: '请填写成本佣金', trigger: 'blur' },
                ],
            },
            num:0,
            okNum:0,
            viewRow:{},
            isMeDetail:false,
            tempDetailData:[],
            titleModel: { title:""},
            titleVisible:false,
            releaseSelection:[],
        }
    },
    created(){
        commissionGetAll({},(res)=>{
            this.commissions=res.Result;
        });
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
       
    },
    methods: {
        setSwipeRemark(scope){
            this.$prompt('请输入商家要求', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:scope.Remark,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                orderSetSwipeRemark({
                    detailId:scope.Id,
                    swipeRemark:value,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.taskGetDetail(this.task);
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        abandoned(scope){
            taskAbandoned({
                id:scope.Id
            },(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    scope.Status=5;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        pause(scope){
            this.$confirm('中止后将调度将无法继续派单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                taskGroupEnd({
                    taskId:scope.Id
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            }).catch(() => {
                
            });
            // console.log(scope);
        },
        changeIsMeDetail(){
            let newData=[];
            if(this.isMeDetail){
                this.tempDetailData=[];
                this.details.forEach(x=>{
                    this.tempDetailData.push(x);
                    if(x.MyOrderCount>0){
                        newData.push(x);
                    }
                });
                this.details=newData;
            }else{
                this.tempDetailData.forEach(x=>{
                    newData.push(x);
                })
                this.tempDetailData=[];
                this.details=newData;
            }
        },
        setKey(scope,type){
            var val;
            if(type==1){
                val=scope.Spec;
            }else{
                val=scope.KeyWords;
            }
            this.$prompt('请输入新值', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:val,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                 if(type==1){
                    scope.Spec=value; 
                }else{
                    scope.KeyWords=value; 
                }
                orderSetKey({
                    detailId:scope.Id,
                    spec:scope.Spec,
                    keyWords:scope.KeyWords,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.taskGetDetail(this.task);
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        setPrice(scope,type){
            var val;
            if(type==1){
                val=scope.ShowPrice;
            }else{
                val=scope.Price;
            }
            this.$prompt('请输入新值', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:val,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                 if(type==1){
                    scope.ShowPrice=value; 
                }else{
                    scope.Price=value; 
                }
                orderSetPrice({
                    detailId:scope.Id,
                    showPrice:scope.ShowPrice,
                    price:scope.Price,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.taskGetDetail(this.task);
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        canelInvalid(scope){
            orderCanelInvalid({swipeId:scope.Id},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '取消标记成功',
                        type: 'success'
                    });
                    scope.InvalidDate=null;
                    scope.InvalidNum=0;
                    scope.IsInvalid=false;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        invalid(scope){
            orderInvalid({swipeId:scope.Id},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '标记成功',
                        type: 'success'
                    });
                    scope.InvalidDate=res.Result.InvalidDate;
                    scope.InvalidNum=res.Result.InvalidNum;
                    scope.IsInvalid=true;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        addOrderAction(scope){
            if(this.task.Status!=2){
                this.$message({
                    message: '只有进行中的任务可以添加订单',
                    type: 'warning'
                });
                return;
            }
            this.addOrderModel={
                TaskId:scope.TaskId,
                DetailId:scope.Id,
                ShopId:this.task.ShopId,
                SwipePhone:"",
                OrderCode:"",
                AliTrademanager:"",
                AdvanceMoney:scope.Price*scope.BuyNum,
                Cost:0,
            }
            this.addOrderVisible=true;
            this.setDetailRow=scope;
        },
        addOrder(){
            this.isOperating=true;
            this.$refs["orderForm"].validate((valid) => {
                if (valid) {
                    orderAdd(this.addOrderModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.setDetailRow.OkNum+=1;
                            this.setDetailRow.Orders.push(res.Result);
                            this.addOrderVisible=false;
                        }else{
                            this.$message.error(res.Message);
                        }
                        this.isOperating=false;
                    })
                } else {
                    return false;
                }
            });
        },
        formt(date,fmt) { 
            var o = { 
                "M+" : date.getMonth()+1,                 //月份 
                "d+" : date.getDate(),                    //日 
                "h+" : date.getHours(),                   //小时 
                "m+" : date.getMinutes(),                 //分 
                "s+" : date.getSeconds(),                 //秒 
                "q+" : Math.floor((date.getMonth()+3)/3), //季度 
                "S"  : date.getMilliseconds()             //毫秒 
            }; 
            if(/(y+)/.test(fmt)) {
                    fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
            }
            for(var k in o) {
                if(new RegExp("("+ k +")").test(fmt)){
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
                }
            }
            return fmt; 
        },     
        setExpectedOverTimeSubmit(){
            taskSetExpectedOverTime({id:this.setRow.Id,expectedOverTime:this.setRow.ExpectedOverTime},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    this.setRow.ExpectedOverTime=this.formt(this.setRow.ExpectedOverTime,"yyyy-MM-dd");
                    this.setExpectedOverTimeVisible=false;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        setExpectedOverTime(scope){
            this.setRow=scope;
            this.setExpectedOverTimeVisible=true;
        },
        handleClose(done){
            if(document.getElementById("video1")){
                document.getElementById("video1").src="";
                document.getElementById("video1").load();
            }
            done();
        },
        viewImg(scope){
            this.url=JSON.parse(scope.ResourcesImg);
            this.viewRow=scope;
            this.videoVisible=true;
            setTimeout(() => {
                document.getElementById("video1").src=scope.Video;
                document.getElementById("video1").load();
            }, 100);
        },
        // viewVideo(scope){
        //     this.videoVisible=true;
        //     setTimeout(() => {
        //         document.getElementById("video1").src=scope.Video;
        //         document.getElementById("video1").load();
        //     }, 100);
        // },
        serachSwipe(){
            this.pIndex=1;
            this.querySwipe();
        },
        huanyipi(){
            this.pIndex+=1;
            this.querySwipe();
        },
        fenpei(){
            let ids="";
            this.selDetailRows.forEach(x=>{
                ids+=x.Id+",";
            });
            let swipes="";
            this.selSwipeRow.forEach(x=>{
                swipes+=x.Id+",";
            });
            orderBatchAssign({
                details:ids.substr(0,ids.length-1),
                swipes:swipes.substr(0,swipes.length-1)
            },(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '分配成功',
                        type: 'success'
                    });
                    this.batchDispatchVisible=false;
                    this.taskGetDetail(this.task);
                    
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        batchDispatch(){
            if(this.selDetailRows.length==0){
                this.$message({
                    message: "请选择需要派单的行",
                    type: 'warning'
                });
                return;
            }
            this.pIndex=1;
            this.batchDispatchVisible=true;
            this.querySwipe();
        },
        querySwipe(){
            let ids="";
            this.selDetailRows.forEach(x=>{
                ids+=x.Id+",";
            });
            this.loadingSwipe=true;
            orderGetSwipe({taskId:this.task.Id,shopId:this.task.ShopId,detailId:ids.substr(0,ids.length-1),pIndex:this.pIndex,queryTxt:this.queryTxt},(res)=>{
                
                this.loadingSwipe=false;
                if(res.IsSuccess){
                    this.swipeList=res.Result.list;
                    this.undoneNum=res.Result.undoneNum;
                }else{
                    this.$message.error(res.Message);
                    this.swipeList=[]
                    this.undoneNum=res.Result.undoneNum;
                }
            })
        },
        submitproblem(){
            this.$refs["problemForm"].validate((valid) => {
                if (valid) {
                    this.problemModel.taskId=this.setDetailRow.TaskId;
                    this.problemModel.url=this.setDetailRow.Url;
                    orderSetProblem(this.problemModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '设置成功',
                                type: 'success'
                            });
                            this.setDetailRow.Problem=this.problemModel.problem;
                            this.setDetailRow.Answer=this.problemModel.answer;
                            this.problemVisible=false;
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        submitRequirement(){
            this.$refs["requirementForm"].validate((valid) => {
                if (valid) {
                    // this.requirementModel.id=this.setRequirementRow.Id;
                    // this.requirementModel.swipeAge=this.setRequirementRow.SwipeAge;
                    // this.requirementModel.swipeGender=this.setRequirementRow.SwipeGender;
                    // this.requirementModel.swipeBuyerGoodNum=this.setRequirementRow.SwipeBuyerGoodNum;
                    // this.requirementModel.remark=this.setRequirementRow.Remark;
                    // this.requirementModel.swipeRemark=this.setRequirementRow.SwipeRemark;
                    taskSetRequirement(this.requirementModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '设置成功',
                                type: 'success'
                            });
                            
                            this.setRequirementRow.ExpectedOverTime=this.formt(this.requirementModel.expectedOverTime,"yyyy-MM-dd");
                            this.setRequirementRow.RebateMethod=this.requirementModel.rebateMethod;
                            this.setRequirementRow.Intercept=this.requirementModel.intercept;
                            this.setRequirementRow.SwipeAge=this.requirementModel.swipeAge;
                            this.setRequirementRow.SwipeGender=this.requirementModel.swipeGender;
                            this.setRequirementRow.SwipeBuyerGoodNum=this.requirementModel.swipeBuyerGoodNum;
                            this.setRequirementRow.Remark=this.requirementModel.remark;
                            this.setRequirementRow.SwipeRemark=this.requirementModel.swipeRemark;
                            this.requirementVisible=false;
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        updateProblem(scope){
            this.problemModel={
                taskId:0,
                url:"",
                problem:scope.Problem,
                answer:scope.Answer,
            };
            this.setDetailRow=scope;
            this.problemVisible=true;
        },
        setProblem(scope){
            this.problemModel={
                taskId:0,
                url:"",
                problem:"",
                answer:"",
            };
            this.setDetailRow=scope;
            this.problemVisible=true;
        },
        setRequirement(scope){
            this.requirementModel={
                id:scope.Id,
                expectedOverTime:scope.ExpectedOverTime,
                rebateMethod:scope.RebateMethod,
                intercept:scope.Intercept,
                swipeAge:scope.SwipeAge,
                swipeGender:scope.SwipeGender,
                swipeBuyerGoodNum:scope.SwipeBuyerGoodNum,
                remark:scope.Remark,
                swipeRemark:scope.SwipeRemark,
            };
            this.setRequirementRow=scope;
            this.requirementVisible=true;
            
        },
        closeImg(){
            this.showViewer=false;
        },
        readFile(e){
            pushMain(this.task.ShopId,this.setDetailRow.Title ,e.target.files[0],(res)=>{
                console.log(res);
            })
        },
        editImg(scope){
            this.setDetailRow=scope;
            this.$refs.upload.click();
        },
        setTitle(scope){
            this.$prompt('请输入商品标题', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:scope.Title,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                taskSetTitle({
                    detailId:scope.Id,
                    title:value,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.taskGetDetail(this.task);
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        setUrl(scope){
            this.$prompt('请输入商品链接', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue:scope.Url,
            inputPattern: /\S/,
            inputErrorMessage: '不能为空'
            }).then(({ value }) => {
                taskSetUrl({
                    detailId:scope.Id,
                    url:value,
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.taskGetDetail(this.task);
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
       
            });
        },
        showImg(scope){ 
            this.url=[scope.Img];
            this.showViewer=true;
        },
        editTask(scope){
            console.log(scope.StartHour);
            this.overModel={
                id:scope.Id,
                remark:scope.ReviewRemark,
                externalName:scope.ExternalName,
                externalCodes:scope.ExternalCodes,
                startHour:scope.StartHour,
                endHour:scope.EndHour,
            }
            this.overScope=scope;
            this.dialogFormVisible=true;
            this.overType=2;
        },
        taskGetExl(scope){
            window.open(uri+"/TaskBatch/GetExl?id="+scope.Id);
        },
        getExl(){
            //window.location.href = "https://hlqimgnew.oss-cn-beijing.aliyuncs.com/%E5%A4%96%E6%94%BE%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";   

            window.open("https://hlqimgnew.oss-cn-beijing.aliyuncs.com/%E5%A4%96%E6%94%BE%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx");
        },
        overTask(scope){
            this.$confirm('确认结算此工单吗,?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                taskOverTaskNoDetail({
                    taskId:scope.Id
                },(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '任务已成功结算',
                            type: 'success'
                        });
                        this.caozuo=false;
                        this.task.Status=3;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        readExcel(e) {
            var msg="确定将所选批次回单吗?";
            this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                let ids=[];
                this.releaseSelection.forEach(x=>{
                    ids.push(x.Id);
                });
            this.isOperating=true;
            const files = e.target.files;
            if (files.length <= 0) {
                //如果没有文件名
                return false;
            }
            const fileReader = new FileReader();
            fileReader.onload = ev => {
            try {
                const data = ev.target.result;
                const workbook = XLSX.read(data, {
                    type: "binary"
                });
                const wsname = workbook.SheetNames[0]; //取第一张表
                const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //获取到XLSX表格中的数据,并生成json格式的数据类型
                let arr = [];
                ws.forEach((value, index, ws) => {
                    arr.push({
                            Id:0,
                            TaskId:this.task.Id,
                            DetailId:0,
                            Title:ws[index]["商品名称"].toString().trim(),
                            Url:ws[index]["商品链接"].toString().trim(),
                            KeyWords:ws[index]["商品搜索关键字"].toString().trim(),
                            OrderCode:ws[index]["买手提交单号"].toString().trim(),
                            AliTrademanager:ws[index]["买手旺旺名称"].toString().trim(),
                            OrderTime:ws[index]["接单时间"].toString(),
                            AdvanceMoney:ws[index]["买手实际垫付金额"],
                            Cost:ws[index]["第三方佣金"],
                            ActualCommission:0,
                            IsRefund:false,
                            Status:11,
                            PayStatus:3,
                            ReviewNotes:"",
                            SwipeId:0,
                    })
                })
                    taskExistDetail({json:JSON.stringify(arr),ids:JSON.stringify(ids)},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                            message: '导入成功',
                            type: 'success'
                        });
                        if(res.Message!=""){
                            this.$notify({
                            title: '警告',
                            message: res.Message,
                            type: 'warning',
                            duration: 0
                        });
                        }
                        
                        }
                        else{
                            this.$notify({
                            title: '警告',
                            message: res.Message,
                            type: 'warning',
                            duration: 0
                        });
                        }
                    });
                } catch (e) {
                    this.$message({
                        message: e,
                        type: 'warning'
                    });
                    return false;
                }
                
            };
            fileReader.readAsBinaryString(files[0]);
            this.isOperating=false;
            }).catch(() => {
      
            });
        },

        
        readExcelNoMatch(e) {
            var msg="确定将所选批次回单吗?";
            this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                let ids=[];
                this.releaseSelection.forEach(x=>{
                    ids.push(x.Id);
                });
            this.isOperating=true;
            const files = e.target.files;
            if (files.length <= 0) {
                //如果没有文件名
                return false;
            }
            const fileReader = new FileReader();
            fileReader.onload = ev => {
            try {
                const data = ev.target.result;
                const workbook = XLSX.read(data, {
                    type: "binary"
                });
                const wsname = workbook.SheetNames[0]; //取第一张表
                const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //获取到XLSX表格中的数据,并生成json格式的数据类型
                let arr = [];
                ws.forEach((value, index, ws) => {
                    arr.push({
                            Id:0,
                            TaskId:this.task.Id,
                            DetailId:0,
                            Title:ws[index]["商品名称"],
                            Url:ws[index]["商品链接"],
                            KeyWords:ws[index]["商品搜索关键字"],
                            OrderCode:ws[index]["买手提交单号"].toString().trim(),
                            AliTrademanager:ws[index]["买手旺旺名称"].toString().trim(),
                            OrderTime:ws[index]["接单时间"].toString(),
                            AdvanceMoney:ws[index]["买手实际垫付金额"],
                            Cost:ws[index]["第三方佣金"],
                            ActualCommission:0,
                            IsRefund:false,
                            Status:11,
                            PayStatus:3,
                            ReviewNotes:"",
                            SwipeId:0,
                    })
                })
                    taskExistDetailNoMatch({json:JSON.stringify(arr),ids:JSON.stringify(ids)},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                            message: '导入成功',
                            type: 'success'
                        });
                        if(res.Message!=""){
                            this.$notify({
                            title: '警告',
                            message: res.Message,
                            type: 'warning',
                            duration: 0
                        });
                        }
                        
                        }
                        else{
                            this.$notify({
                            title: '警告',
                            message: res.Message,
                            type: 'warning',
                            duration: 0
                        });
                        }
                    });
                } catch (e) {
                    this.$message({
                        message: e,
                        type: 'warning'
                    });
                    return false;
                }
                
            };
            fileReader.readAsBinaryString(files[0]);
            this.isOperating=false;
            }).catch(() => {
      
            });
        },

        toTime(numb, format){
            const time = new Date((numb - 1) * 24 * 3600000 + 1)
            time.setYear(time.getFullYear() - 70)

            var timea=time.valueOf();
            var h=8; //h為小時數
            timea=timea-(h*3600*1000); //可加可減
            timea=new Date(timea);

            const year = timea.getFullYear() + ''
            const month = timea.getMonth() + 1 + ''
            const date = timea.getDate() - 1 + ''
            const hours = timea.getHours();
            const minutes = timea.getMinutes();
            const seconds = timea.getSeconds();
            const t = hours+":"+minutes+":"+seconds;
            if (format && format.length === 1) {
                return year + format + month + format + date + " " + t
            }
            return year + (month < 10 ? '0' + month : month) + (date < 10 ? '0' + date : date)
        },
        importExcel(){
            this.$refs.uploadExcel.click();
        },
        importExcelNoMatch(){
            this.$refs.uploadExcelNoMatch.click();
        },
        taskGetDetail(v){
            taskGetDetail({taskId:v.Id},(res)=>{
                this.details=res.Result;
                this.num=0;
                this.okNum=0;
                this.isMeDetail=false;
                this.details.forEach(x=>{
                    this.num+=x.Num;
                    this.okNum+=x.OkNum;
                });
                this.drawer=true;
                this.task=v;
                if(v.Status==2){
                    this.caozuo=true;
                }
            })
        },
        submitOver() {
            if(this.overScope.startHour<8||this.overScope.startHour>18){
                this.$message({
                    message: '开始时间不能小于8点，不能大于18点',
                    type: 'warning'
                });
                return false;
            }
            if(this.overScope.endHour<9||this.overScope.endHour>21){
                this.$message({
                    message: '结束时间不能小于9点，不能大于21点',
                    type: 'warning'
                });
                return false;
            }
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    if(this.overType==1){
                        taskBatchPass(this.overModel,(res)=>{
                            if(res.IsSuccess){
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.dialogFormVisible=false;
                                this.overScope.Status=2;
                                this.overScope.ReviewTime=res.Result.ReviewTime;
                                this.overScope.ReviewManagerName=res.Result.ReviewManagerName;
                                this.overScope.ExternalName=this.overModel.externalName;
                                this.overScope.ExternalCodes=this.overModel.externalCodes;
                                this.overScope.ReviewRemark=this.overModel.remark;
                            }else{
                                this.$message.error(res.Message);
                            }
                        });
                    }else if(this.overType==2){
                        taskEdit(this.overModel,(res)=>{
                            if(res.IsSuccess){
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.dialogFormVisible=false;
                                this.overScope.ExternalName=this.overModel.externalName;
                                this.overScope.ExternalCodes=this.overModel.externalCodes;
                                this.overScope.ReviewRemark=this.overModel.remark;
                            }else{
                                this.$message.error(res.Message);
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        pass(scope){
            this.overScope=scope;
            this.overType=1;
            this.overModel={
                id:scope.Id,
                remark:"",
                externalCodes:"",
                externalName:"",
                startHour:scope.StartHour,
                endHour:scope.EndHour,
            };
            this.dialogFormVisible=true;
        },
        // overTask(scope){

        // },
        over(scope){
            this.$prompt('请填写不通过原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                }).then(({ value }) => {
                    taskBatchOver({remark:value,id:scope.Id},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.Status=4;
                            scope.ReviewTime=res.Result.ReviewTime;
                            scope.ReviewRemark=value;
                            scope.ReviewManagerName=res.Result.ReviewManagerName;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消操作'
                });       
            });

        },
        query(){
            this.isLoading=true;
            taskBatchGet({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
                payMode:this.queryModel.payMode==""?0:parseInt(this.queryModel.payMode),
                status:this.queryModel.status==""?-1:parseInt(this.queryModel.status),
                createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes),
                isMe:this.queryModel.isMe,
                hasAbandoned:this.queryModel.hasAbandoned,
                reviewRemark:'WF'
            },(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                payMode:"",
                status:"",
                createTimes:[],
                isMe:false,
                hasAbandoned:false,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        },
        handleSelectionChange(val) {
            this.selDetailRows = val;
            this.releaseSelection = val;
        },
        swipeSelectionChange(val){
            this.selSwipeRow = val;
        }

    }
}
</script>
<style scoped>
.row{
    margin-top:10px;
    margin-bottom: 10px;
}
</style>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>